import React from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import UnifiedSearch from "components/UnifiedSearch";

const OuterWrapper = styled.section`
  background-color: ${({ theme }) => theme.themeColors.lightGreen1};
  display: flex;
  justify-content: flex-start;
  padding: 1.25rem 1.5625rem 1.25rem 1.5625rem;
  position: relative;
  z-index: 3;

  ${({ theme }) => theme.mq.lg`
    padding: 1.25rem 1.875rem 1.25rem 1.875rem;
  `}
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 71.25rem;
  width: 100%;

  form {
    display: grid;
    margin: 0 auto;
    row-gap: 1.875rem;
    width: 100%;
    column-gap: 1.25rem;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;

    ${({ theme }) => theme.mq.lg`
      grid-template-columns: 1fr 1fr auto 1fr;
      grid-template-rows: 1fr;
    `}

    button {
      grid-row: 3 / 4;

      ${({ theme }) => theme.mq.lg`
        grid-column: auto;
        grid-row: auto;
        width: 9.5625rem;
      `}
    }
  }
`;

function BusinessSearchBar({ theme }) {
  return (
    <OuterWrapper>
      <InnerWrapper>
        <UnifiedSearch theme={theme} />
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default withTheme(BusinessSearchBar);

BusinessSearchBar.propTypes = {
  theme: PropTypes.shape({
    themeColors: PropTypes.shape({
      darkGreen1: PropTypes.string,
    }),
  }),
};

BusinessSearchBar.defaultProps = {
  theme: undefined,
};
